<template>
  <!-- <div class="bg_gradient"> -->
  <div class="bgImage">
    
    <ContentHeader class="mainHeader"></ContentHeader>
    <LandingPageNew class="mainBody"></LandingPageNew>
    <ContentFooter class="mainFooter"></ContentFooter>
  </div>

</template>

<script>
// import LandingPage from '../views/LandingPage.vue';
import LandingPageNew from '../views/LandingPageNew.vue';
import ContentFooter from './ContentFooter.vue'
import ContentHeader from './ContentHeader.vue'
export default {
  name: 'LandingPageLayout',
  components: {
    // LandingPage
    LandingPageNew,
    ContentFooter,
    ContentHeader
  }
}
</script>

<style scoped>
/* c55a11
  029bd4
*/
.bg-transparent {
  background-color: transparent !important;
}
.spacetop{
    width: 100%;
    height: 90px;
    /* background: red; */
}
.mainHeader {
  height: 20vh;
}
.mainBody {
  height: 65vh;
}
.mainFooter {
  height: 10vh;
}



</style>
